import * as CoreActions from './../../state/actions/core.actions';
import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { Timezone } from '../models/timeZone';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { MasterLookupService } from '../master-services/master-lookup.service';
import { MasterMyProfileService } from '../master-services/master-my-profile.service';
import { Language } from '../models/language';
import { MyProfile } from '../models/myProfile';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MyProfileView } from '../models/myProfileView';
import { CustomValidator } from 'src/app/shared/services/custom-validator';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { NewPassword } from '../models/newPassword';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { MustMatch } from 'src/app/shared/services/compare.validator';
import { DirtyFormChecker } from 'src/app/shared/routeguards/DirtyFormChecker';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/app.state';
import { getIdentityProviderType,getACLicenseStatus,getLTLicenseStatus, GetUserPermissionList } from 'src/app/state/index';
import { IdentityProviderType } from 'src/app/admin/user/shared/models/loginprovider.enum';
import { LobbySettingsService } from '../../shared/services/lobby-settings.service';
import { NotificationGroupPopupComponent } from '../../shared/modalpopup/notification-Group/notification-group-popup/notification-group-popup.component';
import { DialogService } from '@progress/kendo-angular-dialog';
import EmailValidator from 'src/app/shared/validators/generic-email-validator';
import { IdentityServiceService } from 'src/app/admin/system-configuration/shared/services/identity-service.service';
import { TenantConfiguration } from 'src/app/admin/system-configuration/shared/models/tenant-configuration';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { LobbyTabConfig } from 'src/app/shared/models/default-lobby-tab';
import { tap } from 'rxjs/operators';
import IConferencingProviderConfiguration from '../models/conferencingProviderConfiguration';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/admin/user/shared/services/user.service';
import { getQueryParameterByName } from 'src/app/shared/utils/query-param-extractor';
import { SystemConfigurationService } from 'src/app/admin/system-configuration/shared/services/system-configuration.service';

export declare const window: any;

@Component({
  selector: 'app-master-my-profile',
  templateUrl: './master-my-profile.component.html',
  styleUrls: ['./master-my-profile.component.scss']
})
export class MasterMyProfileComponent implements OnInit, DirtyFormChecker {

  showCurrrentPassword = false;
  showNewPassowrd = false;
  showReEnterPassword = false;
  myProfile: MyProfileView;
  timeZoneList: Timezone[] = [];
  languages: Language[] = [];
  myProfileSettingsForm: FormGroup = {} as FormGroup;
  passwordResetForm: FormGroup = {} as FormGroup;
  profileSaveError = '';
  passwordErrors: string[] = [];
  @Output() dirtyEmitter = new EventEmitter<boolean>(false);
  @ViewChild('acc', { static: true }) accordion: NgbAccordion | null = null;
  forgotPwUrl: string = "";
  public invalidPhoneNumber: boolean = false;
  isACLicenseEnabled$?: Observable<boolean>;
  isLTLicenseEnabled$?: Observable<boolean>;
  public defaultLobbyTabsMerges : LobbyTabConfig[] = [];
  public defaultNewLobbyTabs : LobbyTabConfig[] = [];
  /* Determine whether or not to show the password reset option. This will be hidden if the current user logged in through external IDP*/
  showPasswordReset = true;
  userId: string = '';
  externalUserId: string = '';

  virtualConferencingAuthStatus: boolean = false;
  conferencingAuthorizedMessage: string = "";
  conferencingUnauthorizedMessage: string = "";
  // These should be strongly typed
  supportedConferencingProviders: string[] = [];
  currentConferencingProvider!: IConferencingProviderConfiguration;
  private subs = new Subscription();
  public userPermissionList: number[] = [];
  ngDefaultSelected: string = "";
  public tenantConfiguration: TenantConfiguration | null = null;
  public appointmentQueueText: string = '2';
  private listenerAdded = false;
  private hasHandledAuthCode = false;
  constructor(
              private lookupService: MasterLookupService,
              private myProfileService: MasterMyProfileService,
              private formBuilder: FormBuilder,
              private toastService: ToastService,
               private dialogService: DialogService,
              private store: Store<State>,
              public globalDataService: GlobalDataService,
              public oauthService: OAuthService,
              public lobbySettingsService: LobbySettingsService,
              private tenantConfigService: IdentityServiceService,
              private translationLoaderFacade: TranslationLoaderFacade,
              private translateService: TranslateService,
              public userService: UserService,
              private systemConfigurationService: SystemConfigurationService,
               
              ) {
    this.myProfile=this.initializeProfileData();
    this.initializeMySettingsForm();
    this.initializePasswordResetForm();
    this.loadProfilePageData();
  }

  hasUnsavedData(): boolean {
    return this.myProfileSettingsForm.dirty || this.passwordResetForm.dirty;
  }


  ngOnInit() {
    this.defaultLobbyTabsMerges = this.lobbySettingsService.getDefaultLobbyTabsMerges();
    this.defaultNewLobbyTabs = this.lobbySettingsService.getNewDefaultLobbyTabs();
    this.subs.add(
      this.tenantConfigService.getSystemConfiguration().subscribe(result => {
        this.tenantConfiguration = result;
      })
    );
    this.isLTLicenseEnabled$=this.store.select(getLTLicenseStatus);
    this.isACLicenseEnabled$=this.store.select(getACLicenseStatus);
    const idToken = this.oauthService.getIdToken();
    this.forgotPwUrl = this.myProfileService.setForgotpasswordUrl(idToken);
    const loginTypeSubscription = this.store.select(getIdentityProviderType)
                    .subscribe((loginType?: IdentityProviderType) => this.onLoggedUserLoginTypeReceived(loginType));
    this.subs.add(loginTypeSubscription);
    this.conferencingUnauthorizedMessage = this.translateService.instant('_User_Additional_Account_Not_Authorize_Text_');
   
  }

  getConferencingProvider() {
    this.userService.getConferencingProvider().subscribe({
      next: (data) => {
        this.userService.setConferencingProvider(data);
      },
      error: () => {
      }
    });
  }

  checkUserAuthenticate(userId: string) {
    this.lookupService.getConferencingProviderAuthenticationStatus(userId).subscribe({
      next: (isAuthorized: string) => {
        if (isAuthorized =='true') {
          this.virtualConferencingAuthStatus = true;
        }
        else {
          this.virtualConferencingAuthStatus = false;
        }
      },
      error: () => {
      }
    });
    }

  public authorize(event: MouseEvent) {
    event.preventDefault();
    this.hasHandledAuthCode = false;
    this.lookupService.getCurrentConferencingProviderDetails().subscribe({
      next: (result) => {
        if (result != null) {
          this.currentConferencingProvider = result;
          this.openConferencingWindow();
        }
      },
      error: (err) => {
      }
    });
  }

  private openConferencingWindow() {
    let w = 500;
    let h = 400;
    let title = 'Login';
    let left = (screen.width / 2) - (w / 2);
    let top = (screen.height / 2) - (h / 2);
    let url = null;
    const cp = this.currentConferencingProvider;
    cp.redirectUri = this.myProfileService.appConfig?.authentication.myAccountUrl ?? '';

    let authWindowUrl = '';
    if (cp.providerId == 1) { 
      authWindowUrl = 'https://api.getgo.com/oauth/v2/authorize?client_id=' + cp.clientId + '&response_type=code&redirect_uri=' + encodeURIComponent(cp.redirectUri);
    }
  
    if (cp.providerId ==4) {
      authWindowUrl = 'https://webexapis.com/v1/authorize?client_id=' + cp.clientId + '&response_type=code&redirect_uri=' + encodeURIComponent(cp.redirectUri) + '&scope=meeting%3Arecordings_read%20spark%3Akms%20meeting%3Aschedules_read%20meeting%3Apreferences_write%20meeting%3Arecordings_write%20meeting%3Apreferences_read%20meeting%3Aschedules_write&state=set_state_here';
    }
    
    if (cp.scope)
      authWindowUrl = authWindowUrl.concat(`&scope=${cp.scope}`);

    if (cp.state)
      authWindowUrl = authWindowUrl.concat(`&state=${cp.state}`);

    const scalingRatio = 1.7;
    // const windowRef = window.open(authWindowUrl, 'Provider Login', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=${screen.width / scalingRatio}, height=${screen.height / scalingRatio}, top=${(screen.height - (screen.height / scalingRatio)) / 2.1}, left=${(screen.width - (screen.width / scalingRatio)) / 2}`);
    const windowRef = window.open(authWindowUrl, 'Provider Login', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

  
    if (!this.listenerAdded) {
    window.addEventListener('message', this.handleAuthorizationCode.bind(this));
      this.listenerAdded = true;
    }
  }

  private handleAuthorizationCode(event: MessageEvent) {
      this.doValidationBeforeAuth(event)
      var authorizedData = this.getConferencingObj(event)
    if (authorizedData.code && !this.hasHandledAuthCode) {
      this.hasHandledAuthCode = true;
      window.removeEventListener('message', this.handleAuthorizationCode.bind(this));
    this.systemConfigurationService.authorizeProvider(authorizedData).subscribe({
      next: (result) => {
        this.virtualConferencingAuthStatus = result;
        this.conferencingAuthorizedMessage = this.translateService.instant('_User_Additional_Authorization_Success_Text_');
        window.close();
      },
      error: (err) => {
        window.close();
        this.conferencingAuthorizedMessage = this.translateService.instant('_User_Additional_Account_Not_Authorize_Text_');
      }
    });
    (event.source as Window).close();
  
    }
    window.close();
  }
  private getConferencingObj(event: MessageEvent<any>) {
    return {
      code: encodeURIComponent(event.data),
      providerId: this.currentConferencingProvider.providerId,
      userId: this.externalUserId,
      redirectUrl: this.myProfileService.appConfig?.authentication.myAccountUrl ?? ''
    };
  }

  doValidationBeforeAuth(event:MessageEvent){
    let isObject = this.isPlainObject(event.data);
    if (isObject) {
      return;
    }
   
  }
  isPlainObject(value: string) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  static postAuthorizationCodeToParentWindow() {
    const virtualConfProviderAuthorizationCode = getQueryParameterByName('code', window.location.href);
    window.opener.postMessage(virtualConfProviderAuthorizationCode, "*");
  }


  private initializeProfileData(): MyProfileView {
    return {
      userId: null,
      firstName: null,
      lastName: null,
      email: null,
      secondaryEmail: null,
      phoneNumber: null,
      preferredTimeZone: null,
      preferredLanguage: null,
      defaultLobbyTab: null,
      defaultCentralView: null,
      username: null,
      supervisor: null,
      userGroups: null,
      permissionGroup: null,
      notificationGroups: [],
      allowVirtualAppointments: false,
      externalUserId: null
    };
  }

  public getValidator() {
    return CustomValidator;
  }

  public redirectToPasswordReset() {
    this.globalDataService.sendToForgotPassword();
  }

  private loadProfilePageData() {
    const res1$ = this.lookupService.getTimeZones();
    const res2$ = this.lookupService.getLanguages();
    const res3$ = this.myProfileService.getLoggedUserProfile();

    forkJoin(res1$, res2$, res3$).subscribe(results => {
      this.timeZoneList = results[0];
      this.languages = results[1];
      this.languages.forEach(lang => {
        if(lang.languageCode == 'en-US') {
          lang.languageName = "_General_English_EN_Text_";
        }
        else if(lang.languageCode == 'es-mx') {
          lang.languageName = "_General_Spanish_ES_Text_";
        }
        if (results[2].allowVirtualAppointments) {
        this.externalUserId = results[2].externalUserId!;
          this.getConferencingProvider();
        this.checkUserAuthenticate(this.externalUserId);
        }
       
      })
      this.myProfile = results[2];
      this.myProfileSettingsForm.patchValue(
        {
          firstName: this.myProfile.firstName,
          lastName: this.myProfile.lastName,
          username: this.myProfile.username,
          preferredLanguage: this.myProfile.preferredLanguage,
          preferredTimezone: this.myProfile.preferredTimeZone,
          primaryEmail: this.myProfile.email,
          phoneNumber: this.myProfile.phoneNumber,
          secondaryEmail: this.myProfile.secondaryEmail,
          supervisor: this.myProfile.supervisor,
          defaultLobbyTab: this.myProfile.defaultLobbyTab,
          permissionGroup: this.myProfile.permissionGroup,
          notificationGroups: this.myProfile.notificationGroups!=null && this.myProfile.notificationGroups.length>0  ? this.myProfile.notificationGroups[0]:'',
        }
      );
      this.generateDefaultLobbyTabWithUserPermisson();
    }, error => this.toastService.showError('_My_Account_Retrieving_Profile_Details_Failed_Ts_Text_'));
   // this.myProfileSettingsForm.controls['preferredLanguage'].disable();
  }

  public checkForDirty() {
    this.myProfileSettingsForm.valueChanges.subscribe(value => {
      this.dirtyEmitter.emit(true);
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.myProfileSettingsForm.controls; }

  get f2() { return this.passwordResetForm.controls; }

  get phoneNumber() {
    return this.myProfileSettingsForm.get('phoneNumber');
  }

  public saveMyProfile(myProfileFormValues: any) {
    const profileUpdate: MyProfile = {
      userId: this.myProfile.userId,
      firstName: myProfileFormValues.firstName,
      lastName: myProfileFormValues.lastName,
      email: myProfileFormValues.primaryEmail,
      phoneNumber: myProfileFormValues.phoneNumber,
      secondaryEmail: myProfileFormValues.secondaryEmail,
      preferredTimeZone: myProfileFormValues.preferredTimezone,
      preferredLanguage: myProfileFormValues.preferredLanguage,
      defaultLobbyTab: myProfileFormValues.defaultLobbyTab
    }

    this.myProfileService.saveLoggedUserProfile(profileUpdate).subscribe((response) => {
      this.store.dispatch(CoreActions.loadUserInfo());
      this.myProfileSettingsForm.markAsPristine();
      this.translationLoaderFacade.refreshTranslations().subscribe();
      this.toastService.showSuccess('_General_Changes_Saved_Successfully_Ts_Text_');

    }, (errorResponse) => {
      this.toastService.showError('_General_Saving_Failed_Ts_Text_');
    });
  }

  public updatePassword(passwordResetFormValues: any) {
    const encodedCurrentPassword = encodeURIComponent(passwordResetFormValues.currentpassword);
    const encodedNewPassword = encodeURIComponent(passwordResetFormValues.newPassword);
    const encodedRepeatPassword = encodeURIComponent(passwordResetFormValues.repeatPassword);
    // clear existing errors
    this.passwordErrors = [];

    const modifiedPassword: NewPassword = {
      externalUserId: this.myProfile.userId,
      email: this.myProfileSettingsForm.controls['primaryEmail'].value,
      currentPassword: encodedCurrentPassword,
      newPassword: encodedNewPassword,
      repeatPassword: encodedRepeatPassword,
      username: this.myProfile.username
    }

    this.myProfileService.updatePassword(modifiedPassword).subscribe((response) => {
      this.initializePasswordResetForm();
      this.toastService.showSuccess('_General_Changes_Saved_Successfully_Ts_Text_');
    }, (errorResponse) => {
      if (Array.isArray(errorResponse.error)) {
        errorResponse.error.forEach((err: string) => {
          if(err === "Password should have 20 - 64 characters and must contain the following - uppercase letter(s), lowercase letter(s), number(s), special character(s). Password must not contain 2 or more identical characters in a row and 4 or more consecutive repeating words.") {
            this.passwordErrors.push('_My_Account_Password_Character_Conditions_Error_Text');
          } else if (err === "Invalid current password"){
            this.passwordErrors.push('_My_Account_Current_Password_Incorrect_Error_Text');
          } else if (err === "Your new password can not be the same as any of your last 7 passwords. Please choose a new password.") {
            this.passwordErrors.push('_My_Account_Password_History_Condition_Error_Text');
          } else {
            this.passwordErrors.push(err);
          }
        });
      } else {
        this.toastService.showError('_General_Saving_Failed_Ts_Text_');
      }
    });
  }

  togglePanel(id: string) {
    if (this.accordion != null)
      this.accordion.toggle(id);
  }

  avoidSpace(event: any) {
    const k = event ? event.which : window.event.keyCode;
    if (k === 32) {
      return false;
    }

    return true;
  }

  private initializeMySettingsForm() {
    this.myProfileSettingsForm = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.maxLength(50)]],
      username: ['', [Validators.required, Validators.email],{disabled: true }],
      permissionGroup: ['', [Validators.required]],
      userGroup: [],
      notificationGroups: [],
      preferredTimezone: [],
      primaryEmail: ['', [Validators.required, Validators.maxLength(256), EmailValidator()]],
      secondaryEmail: ['', [Validators.email, Validators.maxLength(256), EmailValidator()]],
      phoneNumber: ['', [Validators.pattern(new RegExp('^[0-9]*$'))]],
      supervisor: [],
      preferredLanguage: [],
      defaultLobbyTab: []
    });
    this.myProfileSettingsForm.controls['username'].disable();
    this.myProfileSettingsForm.controls['permissionGroup'].disable();
    this.myProfileSettingsForm.controls['notificationGroups'].disable();
    this.myProfileSettingsForm.controls['supervisor'].disable();
  }

  private initializePasswordResetForm() {
    this.passwordResetForm = this.formBuilder.group({
      currentpassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      repeatPassword: ['', Validators.required]
    },
      {
        validator: MustMatch('newPassword', 'repeatPassword')
      }
    );
  }

  ToastSuccess(message: string) {
    this.toastService.show(message, {
        classname: 'cc-alert-success cc-alert',
        delay: 3000,
        autohide: true,
    });
}

ToastError(message: string) {
    this.toastService.show(message, {
        classname: 'cc-alert-danger cc-alert ',
        delay: 5000,
        autohide: true,
    });
}

private onLoggedUserLoginTypeReceived(loginType?: IdentityProviderType): void {
  if (loginType != null) {
    this.showPasswordReset = loginType === IdentityProviderType.Local;
  }
}

public onFocusOutPhoneNumber(){
  const phoneNumber = this.myProfileSettingsForm.get('phoneNumber');
  if (phoneNumber && phoneNumber.value.length > 0 && phoneNumber.value.length < 10){
    this.invalidPhoneNumber = true;
  }
  else{
    this.invalidPhoneNumber = false;
  }
}

ngOnDestroy(): void {
  window.removeEventListener('message', this.handleAuthorizationCode.bind(this));
  this.subs.unsubscribe();
  
}
  public openGroupNotificationPopUp(notificationGroupList: Array<string>) {
    const dialog = this.dialogService.open({
      content: NotificationGroupPopupComponent,
    });
    dialog.content.instance.notifiactionGroupList = notificationGroupList;
    dialog.content.instance.filteredList = notificationGroupList;

  }

  omit_special_char(event: any) {
    return !((event?.charCode == 62) || (event?.charCode == 60) || (event?.charCode == 38) || (event?.charCode == 32));
  }

  passwordInputChange(formControlName: string) {
    setTimeout(() => {
      let password = this.passwordResetForm.controls[formControlName].value;
      let forbiddenChars = ['<', '>', '&', ' '];
      for (let char of forbiddenChars) {
          password = password.split(char).join('');
      }
      password = password.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, '');
      this.passwordResetForm.controls[formControlName].setValue(password);
    }, 0);
  }

  public generateDefaultLobbyTabWithUserPermisson() {
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (allUserPermissions != null) {
        this.userPermissionList = allUserPermissions;
        if(this.userPermissionList?.includes(47))
          this.defaultLobbyTabsMerges = this.defaultLobbyTabsMerges;
        else{
          this.defaultLobbyTabsMerges = this.defaultNewLobbyTabs;
          if(this.ngDefaultSelected !=this.appointmentQueueText)
            this.ngDefaultSelected = "1";
        }
      }
    })
  }
}
